import { API } from 'api';
import { apiBasePath, apiName } from 'assets';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { useSuspenseQuery } from '@tanstack/react-query';

const getCompositionType = async (kitId: string) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/results/kit-data/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.RESULTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
  return response;
};

const getCompositionTypeQuery = (kitId: string) => ({
  queryKey: [apiName, `getCompositionType`, kitId],
  queryFn: () => getCompositionType(kitId),
});

export const useCompositionType = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();

  const compositionType = useSuspenseQuery(
    getCompositionTypeQuery(currentKitId ?? ''),
  );

  return { compositionType };
};

export default useCompositionType;
